import { request } from "../utils/request.js"

export const customer_addNew = (pojo, args) => request({
    url: 'customer/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customer_update = (pojo, args) => request({
    url: 'customer/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customer_findPageForManage = (pojo, args) => request({
    url: 'customer/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customer_findPageForSelect = (pojo, args) => request({
    url: 'customer/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customer_findListForManage = (pojo, args) => request({
    url: 'customer/findListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customer_findListForSelect = (pojo, args) => request({
    url: 'customer/findListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customer_changeFrozenStatus = (id, args) => request({
    url: 'customer/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customer_findById = (id, args) => request({
    url: 'customer/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customer_changeDefaultMark = (id, args) => request({
    url: 'customer/changeDefaultMark',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


export const customer_getDefault = (args) => request({
    url: 'customer/getDefault',
    method: 'GET',
    showFailMessage: false,
    showSuccessMessage: false,
    ...args
})


export const customer_deleteById = (id, args) => request({
    url: 'customer/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/customer.js